import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = { text: String }

  copyToClipboard(event) {
    event.preventDefault()

    navigator.clipboard?.writeText(this.textValue)

    this.#displayMessage()
  }

  #displayMessage() {
    const target = this.buttonTarget
    const originalText = target.textContent

    target.textContent = "Copied!"
    target.classList.add("disabled")

    setTimeout(() => {
      target.textContent = originalText
      target.classList.remove("disabled")
    }, 2000)
  }
}
